import React from 'react';
import Card from '../../atoms/Card';
import HeadLineThird from '../../atoms/HeadLineThird';
import { Bar } from 'react-chartjs-2';
import pattern from 'patternomaly';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartOptions } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export interface VisitTimeReporList {
  webldentificationType: string;
  time: string;
  count: number;
}

export interface VisitTimeReportProps {
  crewCountList: number[];
  webCountList: number[];
}

const VisitTimeReport: React.FC<VisitTimeReportProps> = ({ crewCountList, webCountList }) => {
  // 来店予約レポートのx軸 ラベル名
  const labels = ['8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21']
    .map((h) => [`${h}:0〜`, `${h}:15〜`, `${h}:30〜`, `${h}:45〜`])
    .flat();

  // 来店予約レポートのデータ
  // 参考: https://www.chartjs.org/docs/latest/samples/bar/stacked.html
  // data.labels: 横軸のラベル
  //   → ["8:00~", "8:15~", "8:30~", "8:45~", "9:00~", ...]
  // data.datasets:
  const data = {
    labels,
    datasets: [
      {
        label: 'クルー予約',
        data: crewCountList,
        backgroundColor: '#5084D480',
        borderWidth: 1,
        borderColor: '#5084D4',
        stack: '1',
        barPercentage: 1.0,
        categoryPercentage: 1.0,
        xAxisID: 'x1',
      },
      {
        label: 'WEB予約',
        data: webCountList,
        backgroundColor: pattern.draw('disc', '#5084D41A', '#5084D433'),
        borderWidth: 1,
        borderColor: '#5084D4',
        stack: '1',
        barPercentage: 1.0,
        categoryPercentage: 1.0,
        xAxisID: 'x1',
      },
    ],
  };

  // 来店予約レポートのグラフオプション
  // https://www.chartjs.org/docs/latest/general/options.html
  /* istanbul ignore next */
  const chartOptions: ChartOptions<'bar'> = {
    layout: {
      padding: 20,
    },
    responsive: true,
    interaction: {
      mode: 'index' as const,
      intersect: false,
    },
    plugins: {
      legend: {
        align: 'start',
        labels: {
          boxHeight: 16,
        },
      },
    },
    scales: {
      // x1: 「0~」「15~」ラベル
      x1: {
        axis: 'x',
        grid: {
          color: ({ index }) => {
            return index % 4 === 0 ? '#00000026' : '#f0f0f0';
          },
        },
        ticks: {
          autoSkip: false,
          maxRotation: 90,
          minRotation: 90,
          font: {
            size: 7,
          },
          callback(_: string | number, index: number) {
            const label = this.getLabelForValue(index);
            return label.split(':')[1];
          },
        },
        stacked: true,
      },
      // x2: 「8時」「9時」ラベル
      x2: {
        axis: 'x',
        grid: {
          color: 'transparent',
        },
        ticks: {
          maxRotation: 0,
          minRotation: 0,
          font: {
            size: 12,
          },
          callback(_: string | number, index: number) {
            const label = this.getLabelForValue(index);
            if (index % 4 !== 2) return '';
            // 4枠のうちの3番目のみを表示する
            return label.split(':')[0] + '時';
          },
        },
        stacked: true,
      },

      y: {
        axis: 'y',
        ticks: {
          padding: 0,
          callback: (tickValue: string | number) => {
            // 小数点の表示を除去する
            if (Number.isInteger(tickValue)) {
              return String(tickValue).split('.')[0];
            }
            return '';
          },
          stepSize: 1,
        },
        stacked: true,
      },
    },
  };

  return (
    <div className='u-mr24'>
      <HeadLineThird text='時間帯別レポート' className='headline-4 u-mb8' data-testid='visit-time-report--title' />
      <Card className=''>
        <Card.Content>
          <Bar style={{ maxHeight: 360 }} options={chartOptions} data={data} data-testid='visit-time-report--time-report-graph' />
        </Card.Content>
      </Card>
    </div>
  );
};
export default VisitTimeReport;
